$(function() {  
  var productShippingWeightKg = document.getElementById('product-shipping-weight-kg');
  var addonShippingWeightKg = document.getElementById('product-addon-weight');
  
  var recalculateShippingEstimate = (quantity) => {
    if (quantity <= 0) return;
    var baseEstimation = parseInt(productShippingWeightKg.value);
    var addonEstimation = addonShippingWeightKg && 'value' in addonShippingWeightKg ? parseInt(addonShippingWeightKg.value): 0;
    var productShippingEstimate = document.getElementById('product-shipping-estimate');
    var calculation = parseFloat((baseEstimation + addonEstimation) * quantity).toFixed(2);
    console.log(calculation);

    var output = productShippingEstimate.textContent.replace(/([0-9.]+)/, calculation);
    productShippingEstimate.textContent = output;
  }

  if (productShippingWeightKg) {
    $('body').on('qty.product-shipping-estimate', function(e, data) {
      // console.log('changed...');
      recalculateShippingEstimate(data.quantity);
    });
  }
});
